export class TedLimitModel {
	valorMaximoPorDia: number;
	valorPorDia: number;
	valorMaximoPorTransacao: number;
	tempoEsgotado: number;
	tipo: LimiteTransferType;
	faixaHorario: LimiteFaixaHorarioModel;
}

export enum LimiteTransferType {
	TED_DIURNO = 'TED_DIURNO',
	TED_NOTURNO = 'TED_NOTURNO'
}

export class LimiteFaixaHorarioModel {
	horarioInicial: string;
	horarioFinal: string;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/models/tedLimitModel.ts